/**
 * Angular import.
 */
import { Component, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Rxjs import.
 */
import { Subscription } from 'rxjs';

/**
 * Import service.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * Import service.
 */
import { ButtonDirective } from '../../directives/ga.directive';

/**
 * Interface imports.
 */
import { Action } from '../model/eventMarkGoing.model';
import { EventList } from '../model/eventList.model';
/**
 * Constant import.
 */
import { CONTENT_VISIBILITY } from '../../constants/app.constants';
import { ONLINE_EVENT_CARD } from '../../constants/data-testId.constants';

/**
 * Event card component.
 */
@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent implements OnDestroy {



  /**
   * Event mark going status.
   */
  public markStatus: number;

  /**
   * Action information when clicked on mark going.
   */
  public actionData: Action;

  /**
   * Acttion information modal state.
   */
  public isActionModalShown = false;

  /**
   * Event data.
   */
  @Input() eventData: EventList;

  /**
   * Event type.
   */
  @Input() eventType: string;

  /**
   * Modal status.
   */
  public showEventModal: boolean;

  /**
   * Sucess message after mark going.
   */
  public sucessMessage: string;

  /**
   * Event going subscribe/unsubscribe.
   */
  public eventGoingSubscription: Subscription;

  /**
   * Used to store date object.
   */
  public dateObj = new Date();

  /**
   * Which page it is from.
   */
  public pageFrom = this.mls.googleEventText.events_list.category;
  /**
   * Content visibility constant.
   */
  public contentVisibility = CONTENT_VISIBILITY;

  /**
   * Test data id name for the online event card.
   */
  public dataTestId = ONLINE_EVENT_CARD;

  /**
   * Function used to import services from outside of this component.
   */
  constructor(
    public fcs: FunCollectionService,
    private router: Router,
    public postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    public dss: DataStorageService,
    private directive_ser: ButtonDirective) { }


  /**
   * Event card bookmark function.
   */
  productBookmark(): void {
    const sessiontime = { 'start_time': '', 'end_time': '' };

    sessiontime.start_time = this.dateObj.getTime().toString();
    sessiontime.end_time = this.dateObj.getTime().toString();

    this.directive_ser.productDetailEvent(Object.assign({}, sessiontime),
      this.mls.googleEventText.events_list.key5,
      this.eventData.product_type,
      this.eventData.product_type_id,
      this.pageFrom,
      this.dss.user_profile_data.profile.track_id);

    this.fcs.showSuccess('You’ve successfully saved this event', 'Success');
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
  }

  /**
   * Redirect user when click on event card.
   */
  redirectToDetail(): void {
    const sessiontime = { 'start_time': '', 'end_time': '' };

    sessiontime.start_time = this.dateObj.getTime().toString();
    sessiontime.end_time = this.dateObj.getTime().toString();

    this.directive_ser.productDetailEvent(Object.assign({}, sessiontime),
      this.mls.googleEventText.events_list.key4,
      this.eventData.product_type,
      this.eventData.product_type_id,
      this.pageFrom,
      this.dss.user_profile_data.profile.track_id);

    this.router.navigate([`eventv3/detail/${this.eventData.event_id}`]);
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
  }

  /**
   * Navigate to Event Schedule Page.
   */
  navigateToEventSchedule(): void {
    this.router.navigate([`eventv3/schedule/${this.eventData.event_id}`]);
  }

  /**
   * User click on share button.
   */
  productshare(): void {
    const sessiontime = { 'start_time': '', 'end_time': '' };

    sessiontime.start_time = this.dateObj.getTime().toString();
    sessiontime.end_time = this.dateObj.getTime().toString();

    this.directive_ser.productDetailEvent(Object.assign({}, sessiontime),
      this.mls.googleEventText.events_list.key6,
      this.eventData.product_type,
      this.eventData.product_type_id,
      this.pageFrom,
      this.dss.user_profile_data.profile.track_id);

    const x = [{
      share_url: '',
      share_contentt: '',
      product_type: this.eventData.product_type,
      product_type_id: this.eventData.product_type_id
    }];
    this.fcs.productShare(x);
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
  }

  /**
   * User click register button.
   */
  markGoing(id: number): void {

    const sessiontime = { 'start_time': '', 'end_time': '' };

    sessiontime.start_time = this.dateObj.getTime().toString();
    sessiontime.end_time = this.dateObj.getTime().toString();

    this.directive_ser.productDetailEvent(Object.assign({}, sessiontime),
      this.mls.googleEventText.events_list.key2,
      this.eventData.product_type,
      this.eventData.product_type_id,
      this.pageFrom,
      this.dss.user_profile_data.profile.track_id);

    this.eventGoingSubscription = this.postSer.postEventGoing(id).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        this.markStatus = data.status;
        if (data.action !== null) {
          this.isActionModalShown = true;
          this.actionData = data.action;
          this.eventData.user_status = data.data.user_status;
          return;
        }
        if (this.markStatus === 1) {
          this.eventData.registered_user_count = this.eventData.registered_user_count + 1;
          this.eventData.user_status.code = 0;
          this.eventData.user_status = data.data.user_status;
          this.showEventModal = true;
          this.sucessMessage = data.msg;
        // tslint:disable-next-line: deprecation
        } else if (data[status] === 0) {
          this.fcs.errorHandeler(data);
        }
      });
    });
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
  }

  /**
   * Reset information message modal.
   */
  resetActionModal(): void {
    this.isActionModalShown = false;
  }

  /**
   * When user close modal.
   */
  backClicked(): void {
    this.showEventModal = false;
  }

  /**
   * Redirect to view schedule.
   */
  viewSchedule(): void {
    const sessiontime = { 'start_time': '', 'end_time': '' };

    sessiontime.start_time = this.dateObj.getTime().toString();
    sessiontime.end_time = this.dateObj.getTime().toString();

    this.directive_ser.productDetailEvent(Object.assign({}, sessiontime),
      this.mls.googleEventText.events_list.key3,
      this.eventData.product_type,
      this.eventData.product_type_id,
      this.pageFrom,
      this.dss.user_profile_data.profile.track_id);

    this.navigateToEventSchedule();

    // tslint:disable-next-line: deprecation
    event.stopPropagation();
  }

  /**
   * Unsubscribe subscribe data.
   */
  ngOnDestroy(): void {
    if (this.eventGoingSubscription) {
      this.eventGoingSubscription.unsubscribe();
    }
  }

}
